module.exports = __webpack_public_path__ + "img/rock-huge-19.8ad95b1d.png";